
import { getValidToken } from './msalTokenUtil';
import { getApiUrl } from '../authConfig';

/**
 * A centralized fetch utility for making API calls.
 * It automatically adds the 'Content-Type' and 'X-Tenant-ID' headers.
 *
 * @param {string} endpoint - The API endpoint to call (e.g., '/organizations').
 * @param {string} tenantId - The tenant ID for the 'X-Tenant-ID' header.
 * @param {object} options - Optional fetch options (method, body, etc.).
 * @returns {Promise<any>} - The JSON response from the API.
 */
export const apiFetch = async (endpoint, options = {}, account, msalInstance) => {
  const token = await getValidToken(msalInstance, account);

  const updatedOptions = {
    ...options,
    headers: {
      ...options.headers,
      'Authorization': `Bearer ${token}`,
    },
  };

    const response = await fetch(getApiUrl(endpoint), {
        ...updatedOptions
    });

    if (!response.ok) {
        let errText = `Server returned status ${response.status}`;
        try {
            const errJson = await response.json();
            errText = errJson.message || errJson.error || errText;
        } catch (e) {}
        throw new Error(errText);
    }

    return await response
};